<template>
  <div></div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { authApi } from '@/api/client'
import { useAuthStore } from '@/store/auth'

const { supportLogin } = useAuthStore()
const route = useRoute()
const router = useRouter()

onMounted(async () => {
  const isSupport = await supportLogin({
    accessToken: route.query.supportToken as string,
    selectedOrganizationId: route.query.organizationId as string,
    selectedLocationId: route.query.locationId as string
  })
  if (isSupport) {
    const locations = await authApi.getLocations()
    const currentLocation = locations.find((l: any) => l.id === route.query.locationId)
    if (currentLocation) {
      const auth = useAuthStore()
      auth.selectLocation(currentLocation)
      router.push({ name: 'employees' })
    } else {
      router.push({ name: 'locations' })
    }
  } else {
    router.push({ name: 'login' })
  }
})
</script>
